import { DAY, MONTH, WEEK } from "../constant";
import { useRemindersContext } from "../useReminders";
import { DayView } from "./dayView/dayView";
import { MonthView } from "./monthView/monthView";
import { WeekView } from "./weekView/weekView";
import "./gridView.scss";
import { CalenderPopups } from "./calenderPopups";

export function ReminderGridView({members, updateMembers, updateStatus} : any) {
  const { viewType } = useRemindersContext();

  return (
    <div>
      {viewType === DAY ? <DayView {...{members, updateMembers, updateStatus}}/> : viewType === WEEK ? <WeekView {...{members, updateMembers, updateStatus}}/> : viewType === MONTH ? <MonthView {...{members, updateMembers, updateStatus}}/> : <></>}
      <CalenderPopups {...{members, updateMembers, updateStatus}}/>
    </div>
  );
}